import React, { useState } from 'react';
import Page from '../components/Page';
import { useCurrentRegister } from '../controllers/financial.controller';

export default function FinancialRegisterPage() {
  const { data, isLoading } = useCurrentRegister();

  if(isLoading) return <Page><div className="p-3">Loading...</div></Page>;

  const register = data?.register || {};
  const shifts = data?.shifts || [];
  const payments = data?.payments || [];
  const invoices = data?.invoices || {};

  let totalCollected = 0;
  payments.forEach(p => totalCollected += parseFloat(p.total || 0));

  return (
    <Page>
      <div className="container-xl">
        <div className="page-header d-print-none text-white">
          <div className="row g-2 align-items-center">
            <div className="col">
              <h2 className="page-title">Register</h2>
            </div>
          </div>
        </div>

        <div className="page-body">
          <div className="card mb-3">
            <div className="card-body text-center">
              <h2>REGISTER — {register.business_date || 'UNKNOWN'}</h2>
              <span className={`badge ${register.status === 'open' ? 'bg-green' : 'bg-secondary'}`}>
                {register.status?.toUpperCase() || 'UNKNOWN'}
              </span>
            </div>
          </div>

          <div className="card mb-3">
            <div className="card-header"><h3 className="card-title">Shifts in this Register</h3></div>
            <div className="table-responsive">
              <table className="table card-table table-vcenter text-nowrap datatable">
                <thead>
                  <tr>
                    <th>Shift #</th>
                    <th>Cashier</th>
                    <th>Open</th>
                    <th>Close</th>
                    <th>Expected Cash</th>
                    <th>Actual Cash</th>
                    <th>Difference</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {shifts.map((s, idx) => (
                    <tr key={s.id}>
                      <td>#{idx + 1}</td>
                      <td>{s.cashier_name || 'Cashier ' + s.cashier_id}</td>
                      <td>{new Date(s.opened_at).toLocaleTimeString()}</td>
                      <td>{s.closed_at ? new Date(s.closed_at).toLocaleTimeString() : '-'}</td>
                      <td>{s.expected_cash}</td>
                      <td>{s.closing_cash || '-'}</td>
                      <td>{s.cash_difference || '-'}</td>
                      <td>{s.status}</td>
                    </tr>
                  ))}
                  {shifts.length === 0 && <tr><td colSpan="8" className="text-center">No shifts logged for this date.</td></tr>}
                </tbody>
              </table>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className="card">
                <div className="card-header"><h3 className="card-title">Register Sales</h3></div>
                <div className="card-body">
                  <table className="table table-sm table-borderless">
                    <tbody>
                      <tr><td>Total Billed</td><td className="text-end fw-bold">NPR {(invoices.total_billed || 0).toFixed(2)}</td></tr>
                      <tr><td>Total Tax</td><td className="text-end">NPR {(invoices.total_tax || 0).toFixed(2)}</td></tr>
                      <tr><td>Total Discount</td><td className="text-end text-danger">-NPR {(invoices.total_discount || 0).toFixed(2)}</td></tr>
                      <tr><td>Sales Due</td><td className="text-end">NPR {(invoices.due_sales || 0).toFixed(2)}</td></tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            
            <div className="col-md-6">
              <div className="card">
                <div className="card-header"><h3 className="card-title">Register Collections</h3></div>
                <div className="card-body">
                  <table className="table table-sm table-borderless">
                    <tbody>
                      {payments.map(p => (
                        <tr key={p.payment_method}>
                          <td>{p.payment_method}</td>
                          <td className="text-end">NPR {parseFloat(p.total).toFixed(2)}</td>
                        </tr>
                      ))}
                      <tr className="border-top"><td className="fw-bold">Total Collected</td><td className="text-end fw-bold">NPR {totalCollected.toFixed(2)}</td></tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </Page>
  );
}
